export default [
  {
    path: 'org-monitoring',
    name: 'org-monitoring',
    component: () => import('@/views/pages/org-monitoring/RouterView.vue'),
    redirect: { name: 'org-monitoring-list' },
    children: [
      {
        path: '',
        name: 'org-monitoring-list',
        component: () => import('@/views/pages/org-monitoring/OrgMonitoring.vue'),
        meta: {
          pageTitle: 'Org monitoring',
          breadcrumb: [
            {
              text: 'Check Monitoring',
              active: true,
            },
          ],
          resource: 'OrgMonitoring',
        },
      },
      {
        path: ':id/check-monitoring',
        name: 'check-monitoring-list',
        component: () => import('@/views/pages/org-monitoring/CheckMonitoringView.vue'),
        meta: {
          pageTitle: 'Check Monitoring',
          breadcrumb: [
            {
              to: { name: 'org-monitoring' },
              text: 'Check Monitoring',
            },
            {
              text: 'Mark',
              active: true,
            },
          ],
          action: 'read',
          resource: 'CheckMonitoring',
        },
      },
    ],
  },
]
